import { computed } from 'vue';
import { plannerRoute } from '@/router';
import { useCaseSyncStore } from '@/stores/useCaseSyncStore';
import { useUserStore } from '@/stores/userStore';
import type { PlanAct } from '@/domain/plan/planAct';

/** The word the 3D planner's button shows, so this modal quotes what the caller will find. */
const LABELS: Record<PlanAct, string> = {
    approve: 'Approve',
    propose: 'Propose',
    none: '',
};

export function usePlanDownloadWarningViewModel() {
    const caseSync = useCaseSyncStore();
    const user = useUserStore();

    const act = computed(() => user.planAct);

    return {
        act,
        actLabel: computed(() => LABELS[act.value]),
        canCreatePlan: computed(() => act.value !== 'none'),
        plannerPath: computed(() => {
            const caseId = caseSync.case_?.id;
            return caseId ? plannerRoute(Number(caseId)) : '';
        }),
    };
}
